import React, { useEffect, useState } from "react";
import { Spin } from 'antd';
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check_purple_icon.svg';
import { getActions, navigateToView } from "store/appTrack/actions";
import { useNavigate } from "react-router-dom";
import { claimActive, updateFormField } from "store/forms/actions";
import { isAuditor, isCommittee } from "utils";

const ActionList = (props) => {
    const [isReady, setIsReady] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const privileges = useSelector(state => state.user.privileges);
    const view = useSelector(state => state.appTrack.permissions.view);
    const edit = useSelector(state => state.appTrack.permissions.edit);
    const cancel = useSelector(state => state.appTrack.permissions.cancel);
    const groups = useSelector(state => state.user.groups);
    const variables = useSelector(state => state.appTrack.variables);
    const user = useSelector(state => state.user);
    const locales = useSelector(state => state.forms?.localeStrings);
    const actions = useSelector(state => state.appTrack.permissions);
    console.log('🔍 Assignment Test:');
    
    const test1 = actions.approveApplication;
    const test2 = actions?.approveApplication;
    const test3 = actions["approveApplication"];
    
    console.log('- test1:', test1);
    console.log('- test2:', test2);
    console.log('- test3:', test3);
    

    console.log('- Direct inline:', actions?.approveApplication);

    const approveApplication = actions?.approveApplication;
    const rejectApplication = actions?.rejectApplication; 
    const includeApplication = actions?.includeApplication;
    const excludeApplication = actions?.excludeApplication;

    console.log('- approveApplication:', approveApplication);
    console.log('- rejectApplication:', rejectApplication);
    
    const approveApp = approveApplication;
    const rejectApp = rejectApplication;
    
    console.log('- Final approveApp:', approveApp);
    console.log('- Final rejectApp:', rejectApp);

    // Check if user is auditor
    const isUserAuditor = isAuditor(groups);
    const isUserCommittee = isCommittee(groups);

    useEffect(() => {
        let mounted = true;

        const initializeActions = () => {
            dispatch(getActions(props.id))
                .then(() => {
                    if (!mounted) return;
                    
                    if (typeof view !== 'undefined' && 
                        typeof edit !== 'undefined' && 
                        typeof cancel !== 'undefined') {
                        setIsReady(true);
                    }
                })
                .catch((error) => {
                    if (!mounted) return;
                    console.error('Failed to initialize actions:', error);
                    setError(error);
                });
        };

        initializeActions();

        // cleanup to prevent mem leaks
        return () => {
            mounted = false;
        };
    }, [dispatch, props.id, view, edit, cancel]);

    // Error state
    if (error) {
        return (
            <div className="popover-container">
                <div className="popover-item" style={{ color: 'red', padding: '12px' }}>
                    Failed to load actions
                </div>
            </div>
        );
    }

    // loading state ...
    if (!isReady) {
        return (
            <div id={`action-list-for-${props.id}`} className="popover-container">
                <div className="popover-item" style={{ textAlign: 'center', padding: '12px' }}>
                    <Spin size="small" />
                </div>
            </div>
        );
    }

    const onView = (value) => {
        props.open(false);
        navigateToView(navigate, props.id);
    };

    const onEdit = (value) => {
        dispatch(
            updateFormField({
                group: 'task',
                key: 'processInstanceId',
                value: props.id
            })
        );
        dispatch(
            updateFormField({
                group: 'carrier',
                key: 'viewMode',
                value: false
            })
        );
        dispatch(claimActive(navigate, props.id));
    };

    const onApprove = () => {
        props.open(false);
        // auditor modal approve outcome
        if (props.onOpenSubmitModal) {
            props.onOpenSubmitModal('approveAuditor');
        }
    };

    const onReject = () => {
        props.open(false);
        // auditor modal reject outcome
        if (props.onOpenSubmitModal) {
            props.onOpenSubmitModal('rejectAuditor');
        }
    };

        const onInclude = () => {
        props.open(false);
        if (props.onOpenSubmitModal) {
            props.onOpenSubmitModal('approveCommittee'); // Ένταξη
        }
    };

    const onExclude = () => {
        props.open(false);
        if (props.onOpenSubmitModal) {
            props.onOpenSubmitModal('rejectCommittee'); // Απένταξη
        }
    };

    const onCancel = () => {
        props.open(false);
        props.setCancelModal(true);
    };

    return (
        <div id={`action-list-for-${props.id}`} className="popover-container">
            {/* view action*/}
            {view ? (
                <div id="action-button-view" className="popover-item" onClick={() => onView(props.id)}>
                    Προβολή <CheckIcon className="check"/>
                </div>
            ) : null}
            
            {/* approve- reject actions*/}
 {isUserAuditor || isUserCommittee ? (
                <>
                {isUserAuditor && approveApplication ? (  
                    <div id="action-button-approve" className="popover-item approve-action" onClick={() => onApprove(props.id)}>
                        <span>Έγκριση <CheckIcon className="check"/></span>
                    </div>
                ) : null}

                {isUserAuditor && rejectApplication ? (  
                    <div id="action-button-reject" className="popover-item reject-action" onClick={() => onReject(props.id)}>
                        <span>Απόρριψη <CheckIcon className="check"/></span>
                    </div>
                ) : null}

                {isUserCommittee && includeApplication ? (  
                    <div id="action-button-include" className="popover-item approve-action" onClick={() => onInclude(props.id)}>
                        <span>Ένταξη <CheckIcon className="check"/></span>
                    </div>
                ) : null}

                {isUserCommittee && excludeApplication ? (  
                    <div id="action-button-exclude" className="popover-item reject-action" onClick={() => onExclude(props.id)}>
                        <span>Απένταξη <CheckIcon className="check"/></span>
                    </div>
                ) : null}
                </>
            ) : (
                /* Edit action for regular users */
                edit ? (
                    <div id="action-button-edit" className="popover-item" onClick={() => onEdit(props.id)}>
                        <span>Επεξεργασία <CheckIcon className="check"/></span>
                    </div>
                ) : null
            )}
            
            {/* Cancel action - available to all */}
            {cancel ? (
                <div id="action-button-cancel" className="popover-item" onClick={() => onCancel(props.id)}>
                    <span>Ακύρωση <CheckIcon className="check"/></span>
                </div>
            ) : null}
        </div>
    );
};

export default ActionList;